



























































































import * as _ from 'lodash';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { BAvatar } from 'bootstrap-vue';
import { Language, VisitorType } from '../../types/Enum';
import { ShortCutIcon } from '../../types/Interface';
import Shortcut from './Shortcut.vue';
import { redirect } from '../../scripts/utils/redirect';
// statement for optimal bundle sizes


@Component({
  components: {
    BAvatar,
  },
})
export default class BootMenu extends Vue {
  private redirect: Function = (title: string) => { redirect(title, this); };

  @Prop({ required: true }) readonly show!: boolean;


  private setVisitor(type: VisitorType): void {
  }
}
